import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import signIn from '../api/signIn';
import SignInParams from '../types/SignInParams';
import AlertMessages from '@/components/AlertMessages';

const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const [custCode, setCustCode] = useState<string>("")
  const [password, setPassword] = useState<string>("")
  const [alertMessageOpen, setAlertMessageOpen] = useState<boolean>(false)
  const [alertMessages, setAlertMessages] = useState<string[]>([]);
  
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const params: SignInParams = {
      cust_code: custCode,
      password: password
    }

    try {
      await signIn(params);
      setAlertMessageOpen(false);

      navigate('/customer/top');
    } catch (err: any) {
      setAlertMessageOpen(true);
      if (err.response && err.response.data && err.response.data.errors) {
        setAlertMessageOpen(true);
        setAlertMessages(err.response.data.errors);
      } else {
        setAlertMessageOpen(false);
        console.log('An unexpected error occurred:', err);
      }
    }
  }

  return (
    <React.Fragment>
      <main className="wrapper">
        <section>
          <div className="inner">
            <div>
              <div>
                <div>
                  <div className="contact-register ptsp-50">
                    <AlertMessages open={alertMessageOpen} messages={alertMessages} />
                    <form onSubmit={handleSubmit}>
                      <div className="contact-register__item">
                        <label className="contact-register__ttl" htmlFor="cust_code">お客様ID</label>
                        <input
                          name="cust_code"
                          type="text"
                          className="input"
                          id="cust_code"
                          value={custCode}
                          onChange={event => setCustCode(event.target.value)}
                        />
                      </div>
                      <div className="contact-register__item">
                        <label className="contact-register__ttl" htmlFor="password">パスワード</label>
                        <input
                          name="password"
                          type="password"
                          className="input"
                          id="password"
                          onChange={event => setPassword(event.target.value)}
                        />
                      </div>
                      <button type="submit" className="c-btn__01">ログイン</button>
                      <div className="c-al--c">
                        <a className="c-btn__02" href="/customer/forgot_password">※パスワードをお忘れの方はこちら</a>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  )
}

export default LoginForm;